function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router-dom';
import { compact } from 'lodash-es';
import { TableList, Typography, TableListActions, DropdownMenu } from 'seagull';
import { getAgreementPdfUrl } from "../../business-logic/relationshipLogic";
import { LinkIcon, EyeLine, EditLine, EmailSent, Download, DocumentCopy, TrashLiner24, ActivityLiner24 } from 'seagull/icons';
import { useOverlayContext, useIoContext, useStore } from "../../contexts";
import { Intent } from "../../infra/access-control";
import { ClientPreview } from "../../components/ClientPreview/ClientPreview";
import { getStatusUIData, getRowAndMainAction } from "./ProposalsDashboard.utils";
import { relationshipSummaryModel, timeModel } from "../../models";
import { selectors } from "../../store/state-selectors";
import { isExpired } from "../../models/relationship-summary";
import { WithdrawModal } from "./WithdrawModal/WithdrawModal";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function ProposalsDashboardRow(props) {
  const {
    proposal,
    isVendor,
    index,
    refresh,
    onViewActivityLog,
    onViewProposal,
    proposalActions
  } = props;
  const expired = isExpired(proposal);
  const history = useHistory();
  const overlayContext = useOverlayContext();
  const {
    openNewTab
  } = useIoContext();
  const heapId = proposal.isSample ? 'test-proposal' : 'proposals';
  const pdfHost = useStore(selectors.pdfHost);
  const opposingPartyName = relationshipSummaryModel.opposingPartyName(proposal, isVendor);
  const {
    statusText,
    statusSkin,
    lastUpdateText
  } = getStatusUIData(proposal, isVendor);
  const sellerFullName = relationshipSummaryModel.sellerFullName(proposal);
  const {
    getCancelProposalAction,
    getCopyProposalLinkAction,
    getDuplicateProposalAction,
    getEditProposalAction,
    getSendProposalReminderAction
  } = proposalActions;
  const {
    rowProps,
    mainAction
  } = getRowAndMainAction({
    proposal,
    isVendor,
    heapId,
    history,
    openClientPreview
  });
  const onDownloadPDF = proposal => {
    openNewTab(getAgreementPdfUrl(proposal.id, pdfHost));
  };
  function renderSendProposalReminderAction() {
    const {
      intent,
      disabled,
      text,
      onClick
    } = getSendProposalReminderAction(proposal.id, proposal.isSample);
    return /*#__PURE__*/_jsx(DropdownMenu.Item, {
      intent: intent,
      disabled: disabled,
      onClick: onClick,
      iconStart: /*#__PURE__*/_jsx(EmailSent, {}),
      "data-testid": "proposals-row-send-reminder",
      children: text
    }, "reminder".concat(proposal.id));
  }
  function renderCopyProposalLinkAction() {
    const {
      intent,
      text,
      onClick
    } = getCopyProposalLinkAction(proposal);
    return /*#__PURE__*/_jsx(DropdownMenu.Item, {
      intent: intent,
      onClick: onClick,
      iconStart: /*#__PURE__*/_jsx(LinkIcon, {}),
      "data-testid": proposal.isSample ? 'test-proposal-copy-link' : 'proposals-row-copy-link',
      children: text
    }, "copy-link-".concat(proposal.id));
  }
  function renderDuplicateProposalAction() {
    const {
      intent,
      disabled,
      text,
      onClick
    } = getDuplicateProposalAction(proposal.id, {
      isSampleProposal: proposal.isSample,
      draftId: proposal.draftId
    });
    return /*#__PURE__*/_jsx(DropdownMenu.Item, {
      intent: intent,
      iconStart: /*#__PURE__*/_jsx(DocumentCopy, {}),
      disabled: disabled,
      "data-testid": "proposals-row-duplicate",
      onClick: onClick,
      children: text
    }, "duplicate".concat(proposal.id));
  }
  function renderEditProposalAction() {
    const {
      text,
      intent,
      disabled,
      onClick
    } = getEditProposalAction(proposal, 'proposalsDashboard');
    return /*#__PURE__*/_jsx(DropdownMenu.Item, {
      intent: intent,
      onClick: onClick,
      iconStart: /*#__PURE__*/_jsx(EditLine, {}),
      disabled: disabled,
      "data-testid": "proposals-row-withdraw-to-edit",
      children: text
    }, "withdraw-to-edit".concat(proposal.id));
  }
  function renderCancelProposalAction() {
    const {
      text,
      intent
    } = getCancelProposalAction(proposal.id, refresh);
    const withdrawProposal = () => {
      overlayContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref => {
          let {
            dismissModal
          } = _ref;
          return /*#__PURE__*/_jsx(WithdrawModal, {
            openedBy: "proposals-dashboard",
            relationshipId: proposal.id,
            draftId: proposal.draftId,
            onSuccess: refresh,
            dismissModal: dismissModal
          });
        }
      });
    };
    return /*#__PURE__*/_jsx(DropdownMenu.Item, {
      skin: "error",
      intent: intent,
      iconStart: /*#__PURE__*/_jsx(TrashLiner24, {}),
      "data-testid": proposal.isSample ? 'test-proposal-cancel' : 'proposals-row-cancel',
      onClick: withdrawProposal,
      children: text
    }, "cancel".concat(proposal.id));
  }
  function openClientPreview() {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: props => /*#__PURE__*/_jsx(ClientPreview, _objectSpread({
        type: "relationshipId",
        relationshipId: proposal.id
      }, props))
    });
  }
  const actions = compact([isVendor && /*#__PURE__*/_jsx(DropdownMenu.Item, {
    intent: Intent.VendorViewProposal,
    iconStart: /*#__PURE__*/_jsx(EyeLine, {}),
    "data-testid": "proposals-row-view-proposal",
    "data-heapid": "".concat(heapId, "-review-btn"),
    onClick: () => onViewProposal(proposal),
    children: "View"
  }, "view-proposal".concat(proposal.id)), isVendor && renderEditProposalAction(), isVendor && !expired && renderCopyProposalLinkAction(), isVendor && !expired && renderSendProposalReminderAction(), isVendor && renderDuplicateProposalAction(), isVendor && /*#__PURE__*/_jsx(DropdownMenu.Item, {
    iconStart: /*#__PURE__*/_jsx(ActivityLiner24, {}),
    "data-testid": "view-activity-log",
    onClick: () => onViewActivityLog(proposal),
    children: "View activity log"
  }, "activity".concat(proposal.id)), /*#__PURE__*/_jsx(DropdownMenu.Item, {
    intent: Intent.DownloadAgreementPdf,
    iconStart: /*#__PURE__*/_jsx(Download, {}),
    disabled: proposal.isSample,
    "data-testid": "proposals-row-download-pdf",
    onClick: () => onDownloadPDF(proposal),
    children: "Download PDF"
  }, "dowload-pdf-".concat(proposal.id)), isVendor && renderCancelProposalAction()]);
  return /*#__PURE__*/_jsx(TableList.Row, _objectSpread(_objectSpread({
    intent: mainAction.intent
  }, rowProps), {}, {
    rowId: proposal.id,
    items: [{
      value: /*#__PURE__*/_jsxs(Typography, {
        ellipsis: true,
        weight: "normal",
        "data-testid": "proposals-row-".concat(index, "-name"),
        children: [opposingPartyName, proposal.title && proposal.title !== opposingPartyName && /*#__PURE__*/_jsxs(Typography, {
          as: "span",
          variant: "paragraph2",
          skin: "secondary",
          children: ["\xA0(", proposal.title, ")"]
        })]
      })
    }, {
      value: /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        children: proposal.createdOn ? timeModel.formatDate(proposal.createdOn) : ''
      })
    }, {
      value: sellerFullName != null && /*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        children: sellerFullName
      })
    }, {
      value: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Typography, {
          "data-testid": "row-".concat(index, "-status"),
          "data-skin": statusSkin,
          skin: statusSkin,
          weight: "normal",
          children: statusText
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          size: "small",
          "data-testid": "row-".concat(index, "-status-update"),
          "data-skin": statusSkin,
          skin: statusSkin === 'error' ? 'error' : 'secondary',
          children: lastUpdateText
        })]
      })
    }],
    actionColumn: /*#__PURE__*/_jsx(TableListActions, {
      buttonText: mainAction.buttonText,
      buttonIntent: mainAction.intent,
      testId: proposal.isSample ? 'test-proposal' : "proposals-row-".concat(index),
      btnHeapId: mainAction.btnHeapId,
      menuHeapId: "".concat(heapId, "-menu-btn"),
      onClickButton: mainAction.onClickButton,
      children: actions.length > 0 && actions
    }),
    "data-testid": proposal.isSample ? 'test-proposal' : "proposals-row-".concat(index),
    "data-heapid": heapId
  }), proposal.id);
}